import { Link } from 'react-router-dom';
import PageShell from '../components/PageShell';
import PolicyLayout from './PolicyLayout';
import {
  ADDRESS,
  BRAND_NAME,
  COMPANY_NAME,
  POLICY_UPDATED,
  SITE_DOMAIN,
  SUPPORT_PHONE_LABEL,
  SUPPORT_PHONE_TEL,
} from '../constants/site';

export default function DisclaimerPage() {
  return (
    <PageShell>
      <PolicyLayout
        title="Disclaimer"
        updated={POLICY_UPDATED}
        intro={`Please take a moment with the notices below before relying on ${BRAND_NAME} (${SITE_DOMAIN}), an independent help and information resource owned by ${COMPANY_NAME}.`}
      >
        <h2>We Are Not the Publisher</h2>
        <p>
          The people behind this site are independent technicians who sell support services on their
          own. We have <strong>no</strong> business tie, partnership, sponsorship, or endorsement from
          Software MacKiev, Ancestry.com, FamilySearch, or any other company whose software is
          discussed on these pages.
        </p>

        <h2>Trademarks</h2>
        <p>
          Family Tree Maker, TreeVault, Ancestry, and FamilySearch, as well as every other brand, logo,
          and product name shown here, belong to the companies that own them. We mention them solely
          so readers can tell which programs a guide is about.
        </p>

        <h2>Free Help From the Publisher</h2>
        <p>
          Depending on your product and its warranty status, the publisher may help you at no charge,
          and its official website is open to you at any time. Choosing us is entirely optional; we
          simply offer a personal, independent alternative for those who want it.
        </p>

        <h2>Accuracy of Guides and Articles</h2>
        <p>
          We write our tutorials and FAQs carefully, but they describe typical setups rather than your
          exact computer. New releases and updates can rename menus, add or drop features, and change
          pricing or system requirements. When a detail matters, compare it with the documentation the
          publisher provides.
        </p>

        <h2>No Promise of a Fix or Data Recovery</h2>
        <p>
          No two machines or family files behave quite alike. How a repair turns out hinges on factors
          such as the equipment you own, the version of Windows or macOS installed, your internet
          speed, and how intact your tree file is. We can&apos;t assure you that every fault will be
          cleared, and we make no promise that missing or damaged records can be restored.
        </p>

        <h2>Your Backups Are Your Responsibility</h2>
        <p>
          Save a copy of your tree and its linked photos and documents before you try any step from
          our articles or let a technician connect. {COMPANY_NAME} cannot accept responsibility for
          information that is lost along the way.
        </p>

        <h2>Paid Services</h2>
        <p>
          Some assistance we provide carries a charge, and you will hear the price before anything is
          done. The <Link to="/terms-and-conditions">Terms &amp; Conditions</Link> and the{' '}
          <Link to="/refund-policy">Refund Policy</Link> explain billing and money-back rules in
          full.
        </p>

        <h2>Links to Other Sites</h2>
        <p>
          Now and then we point readers to websites run by others because they may be useful. Those
          sites are outside our control, a link does not mean we vouch for them, and we are not
          answerable for what they publish.
        </p>

        <h2>Reaching Us</h2>
        <p>
          <strong>{COMPANY_NAME}</strong>
          <br />
          {ADDRESS}
          <br />
          Talk to us: <a href={SUPPORT_PHONE_TEL}>{SUPPORT_PHONE_LABEL}</a>
          <br />
          Visit: {SITE_DOMAIN}
        </p>
      </PolicyLayout>
    </PageShell>
  );
}
